module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c(_vm.componentName, {
    tag: "component",
    attrs: {
      "value": _vm.value
    },
    on: {
      "input": _vm.emitInput
    }
  })
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-06bb27fd"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/ui-elements/DynamicControl.vue
// module id = 2436
// module chunks = 1